import './ScoreCard.scss';
import { usePortContext } from '../../../service/MessageChannelContext';

const content = {
  poreSize: {
    en: 'Pore Size',
    id: 'Ukuran Pori',
  },
  darkSpots: {
    en: 'Dark Spots',
    id: 'Dark Spots',
  },
  texture: {
    en: 'Texture',
    id: 'Tekstur',
  },
  acne: {
    en: 'Acne',
    id: 'Jerawat',
  },
  brightness: {
    en: 'Brightness',
    id: 'Kulit Kemerahan',
  },
  skinHealth: {
    en: 'Skin Health',
    id: 'Kesehatan Kulit',
  },
};

const scoreOrder = ['skinHealth', 'acne', 'texture', 'poreSize', 'darkSpots', 'brightness'];

export const ScoreCard = ({ scores, onClick }) => {
  const { lang } = usePortContext();
  return (
    <div className="score-card">
      <div className="scores">
        {Object.entries(scores)
          .sort(([keyA], [keyB]) => {
            return scoreOrder.indexOf(keyA) - scoreOrder.indexOf(keyB);
          })
          .map(([key, score]) => (
            <ScoreItem key={key} score={score} title={content[key][lang]} />
          ))}
      </div>
      <hr />
      <div className="view-more" onClick={onClick}>
        View More...
      </div>
    </div>
  );
};

const getScoreClassName = (score) => {
  if (score <= 4) {
    return 'red';
  }
  if (score <= 7) {
    return 'yellow';
  }
  return 'green';
};

const ScoreItem = ({ score, title }) => {
  return (
    <div className="score-item">
      <div className={`score ${getScoreClassName(score)}`}>{`${score}/10`}</div>
      <div className="score-title">{title}</div>
    </div>
  );
};
